/**
 * THE issue-type glyph set. One icon per type, on every surface.
 *
 * Emily, 2026-09-02: "def should be one set, but also for example dependent
 * on the surface is if it should show text." So this file decides WHICH glyph
 * a type draws, and each surface decides whether a word sits beside it: the
 * dashboard has the room (icon + word), the extension sidebar and the
 * team-review drawer do not (icon only, word in the tooltip and the
 * accessible name).
 *
 * This package ships no React and no icon library, so an entry names the glyph
 * and the surface resolves the name through its own registry of imports:
 *   extension  packages/extension/src/content/IssueTypeIcon.tsx
 *   dashboard  packages/dashboard/src/components/shared/badges/TypeBadge.tsx
 *   drawer     packages/server/src/review-app/components/issue-table/icons.tsx
 * Each registry is pinned to this map by its own test, so a name added here
 * without an import there fails loudly rather than falling back to a stranger.
 *
 * Mismatch is LayoutTwoColumnIcon, a framed square split by a vertical divider
 * (Emily, 2026-09-02: "go with the split square"). It replaced SourceCodeIcon,
 * whose `< >` read as "code" rather than "does not match the design".
 * Accessibility keeps the Solar glyph all three surfaces already drew.
 */
import { ISSUE_TYPE_VALUES } from './issueTypes.js';
export const ISSUE_TYPE_GLYPHS = {
    'design-bug': { library: 'hugeicons', name: 'Bug01Icon' },
    'design-gap': { library: 'hugeicons', name: 'LayoutTwoColumnIcon' },
    improvement: { library: 'hugeicons', name: 'ArrowUp01Icon' },
    general: { library: 'hugeicons', name: 'Comment01Icon' },
    'design-debt': { library: 'hugeicons', name: 'Alert01Icon' },
    accessibility: { library: 'iconify', name: 'solar:accessibility-linear' },
    'design-token': { library: 'hugeicons', name: 'PaintBoardIcon' },
};
/** The glyph for a known value; undefined (never a throw) for anything else. */
export function issueTypeGlyph(value) {
    if (!value || !ISSUE_TYPE_VALUES.includes(value))
        return undefined;
    return ISSUE_TYPE_GLYPHS[value];
}
//# sourceMappingURL=issueTypeGlyphs.js.map